import { render, staticRenderFns } from "./office-budget.vue?vue&type=template&id=61d35b24&"
import script from "./office-budget.vue?vue&type=script&lang=js&"
export * from "./office-budget.vue?vue&type=script&lang=js&"
import style0 from "./office-budget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports